// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"8c96cefaa1f811a5f142","883":"f72052f07391364bd0ec"}[chunkId] + ".js";
};